export default "__VITE_ASSET__DSxaDlUJ__"